import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { dataUser } from './Component/Helpers/util';
import { toast } from 'react-toastify';
import SwOffCanvas from './Component/Common/SwOffCanvas/SwOffCanvas';
import SwButton from './Component/Common/SwButtons/SwButtons';
import SwSelect from './Component/Common/SwReactSelect/SwReactSelect';
import SwInput from './Component/Common/FormComponent/SwInput';
import SwTextArea from './Component/Common/FormComponent/SwTextArea';
import SwRadio from './Component/Common/FormComponent/SwRadio';
import SwCheckbox from './Component/Common/FormComponent/SwCheckbox';

const FeedbackRating = ({ surveyProps, show, onClose, apiDataSurvey }) => {
  const [questions, setQuestions] = useState([]);
  const [ratings, setRatings] = useState([]);
  const [descriptions, setDescriptions] = useState([]);
  const [btnStatus, setBtnStatus] = useState(false);
  const [footerScale, setFooterScale] = useState('');
  const [footerDetail, setFooterDetail] = useState('');
  const [subheader, setSubheader] = useState('');
  const [subheader1, setSubheader1] = useState('');
  const [surveyId, setSurveyId] = useState('');
  const [surveyConfig, setSurveyConfig] = useState('');
  const [locationOptions, setLocationOptions] = useState([]);
  const [showAlternateQuestions, setShowAlternateQuestions] = useState([]);
  const [alternateAnswers, setAlternateAnswers] = useState([]);
  const [multipleChoiceLow, setMultipleChoiceLow] = useState([]);
  const [multipleChoiceHigh, setMultipleChoiceHigh] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const UserObj = JSON.parse(dataUser());

  useEffect(() => {
    if (surveyProps && surveyProps.length > 0) {
      const parsedQuestions = JSON.parse(surveyProps[0].questions);
      setQuestions(parsedQuestions);
      setRatings(Array(parsedQuestions.length).fill(0));
      setDescriptions(Array(parsedQuestions.length).fill(''));
      setShowAlternateQuestions(Array(surveyProps.length).fill(false));
      setAlternateAnswers(Array(surveyProps.length).fill(''));
      setMultipleChoiceLow(Array(surveyProps.length).fill([]));
      setMultipleChoiceHigh(Array(surveyProps.length).fill([]));
      const [scale, ...details] = surveyProps[0].footer.split('\n');
      const [scale1, ...details1] = surveyProps[0].subheader.split('\n');
      setFooterScale(scale);
      setFooterDetail(details.join(' '));
      setSubheader(scale1);
      setSubheader1(details1.join('</br>'));
      setSurveyId(surveyProps[0].survey_id);
      setSurveyConfig(surveyProps[0].survey_config_id);
      const locations = surveyProps[0].locationData.map(location => ({
        value: location.rec_id,
        label: location.location_short_code,
      }));
      setLocationOptions(locations);
    }
  }, [surveyProps]);

  const handleRating = (qIndex, rating) => {
    const newRatings = [...ratings];

    if (newRatings[qIndex] === rating) {
      newRatings[qIndex] = 0;
    } else {
      newRatings[qIndex] = rating;
    }

    setRatings(newRatings);

    const newShowAlternateQuestions = [...showAlternateQuestions];
    const question = questions[qIndex];

    if (newRatings[qIndex] !== 0) {
      if (newRatings[qIndex] <= question.alternateLowFlag) {
        newShowAlternateQuestions[qIndex] = 'low';
      } else if (newRatings[qIndex] >= question.alternateHighFlag) {
        newShowAlternateQuestions[qIndex] = 'high';
      } else {
        newShowAlternateQuestions[qIndex] = false;
      }
    } else {
      newShowAlternateQuestions[qIndex] = false;
    }

    setShowAlternateQuestions(newShowAlternateQuestions);
  };

  const handleDescriptionChange = (qIndex, event) => {
    const newDescriptions = [...descriptions];
    newDescriptions[qIndex] = event.target.value;
    setDescriptions(newDescriptions);
  };

  const handleAlternateAnswerChange = (qIndex, event) => {
    const newAlternateAnswers = [...alternateAnswers];
    newAlternateAnswers[qIndex] = event.target.value;
    setAlternateAnswers(newAlternateAnswers);
  };

  const handleCheckboxChange = (qIndex, option, type) => {
    const newMultipleChoice =
      type === 'low' ? [...multipleChoiceLow] : [...multipleChoiceHigh];
    const currentChoices = newMultipleChoice[qIndex] || [];

    if (currentChoices.includes(option)) {
      newMultipleChoice[qIndex] = currentChoices.filter(
        choice => choice !== option,
      );
    } else {
      newMultipleChoice[qIndex] = [...currentChoices, option];
    }

    if (type === 'low') {
      setMultipleChoiceLow(newMultipleChoice);
    } else {
      setMultipleChoiceHigh(newMultipleChoice);
    }
  };

  const handleSubmitFeedback = e => {
    e.preventDefault();

    if (!selectedOption) {
      toast.error('Please select a location.');
      return;
    }

    for (let i = 0; i < questions.length; i++) {
      const question = questions[i];

      if (i !== 0) {
        if (
          (question.answerType === 1 || question.answerType === 5) &&
          ratings[i] === 0
        ) {
          toast.error(`Please provide a rating for question ${i + 1}.`);
          return;
        }

        if (
          question.answerType !== 1 &&
          question.answerType !== 3 &&
          question.answerType !== 4 &&
          (!descriptions[i] || descriptions[i].trim() === '')
        ) {
          toast.error(`Please provide a description for question ${i + 1}.`);
          return;
        }

        if (question.answerType === 3 && ratings[i] === 0) {
          toast.error(`Please select an option for question ${i + 1}.`);
          return;
        }

        if (
          question.answerType === 4 &&
          (!multipleChoiceLow[i] || multipleChoiceLow[i].length === 0) &&
          (!multipleChoiceHigh[i] || multipleChoiceHigh[i].length === 0)
        ) {
          toast.error(
            `Please select at least one option for question ${i + 1}.`,
          );
          return;
        }
      }

      if (showAlternateQuestions[i]) {
        if (showAlternateQuestions[i] === 'low') {
          if (!multipleChoiceLow[i] || multipleChoiceLow[i].length === 0) {
            if (question?.multipleChoice?.length !== 0) {
              toast.error(`Please select at least one option.`);
              return;
            }
          }
        }
      }
    }

    setBtnStatus(true);

    const getCompanyId = UserObj ? UserObj.company_id : null;
    const localData = JSON.parse(localStorage.getItem('headData'));
    const getUserId = UserObj ? UserObj.rec_id : null;
    const getEmail = UserObj ? UserObj.email : null;

    const questionsArray = questions.map((question, index) => {
      const rating =
        ratings[index] === 0 ? undefined : ratings[index].toString();
      let answer;
      if (
        question.answerType === 3 &&
        ratings[index] === question.multipleChoice.length
      ) {
        answer = descriptions[index];
      } else {
        answer =
          question.answerType === 1 || question.answerType === 5
            ? rating
            : descriptions[index];
      }

      const answerType = question.answerType;

      const multipleAnswerLow =
        question.answerType === 3
          ? [question.multipleChoice[ratings[index] - 1]]
          : multipleChoiceLow[index] || [];

      const multipleAnswerHigh = multipleChoiceHigh[index] || [];

      const filteredMultipleChoice = (question.multipleChoice || []).filter(
        opt => opt && opt.trim(),
      );

      const questionObject = {
        question: question.question,
        answer: answer,
        answerType,
        alternateQuestion: showAlternateQuestions[index]
          ? showAlternateQuestions[index] === 'low'
            ? question.alternateLowQuestion
            : question.alternateHighQuestion
          : '',
        alternateAnswer: alternateAnswers[index] || '',
        multipleChoice: filteredMultipleChoice,
        multipleAnswer: [...multipleAnswerLow, ...multipleAnswerHigh],
      };

      return questionObject;
    });

    const feedbackData = {
      survey_id: surveyId,
      company_id: getCompanyId,
      location_id: selectedOption.value,
      user_id: getUserId,
      email: getEmail,
      questionsArray: questionsArray,
      survey_config_id: surveyConfig,
    };

    const authToken = localData?.spintlyToken;

    axios
      .post(
        `${process.env.REACT_APP_API_URL}survey/sendResponse`,
        feedbackData,
        {
          headers: {
            Authorization: authToken,
          },
        },
      )
      .then(res => {
        if (res?.data?.statusValue === 201) {
          toast.success('Your response has been submitted. Thank You!');
          apiDataSurvey();
          resetValue();
        }
        setBtnStatus(false);
        onClose();
      })
      .catch(err => {
        toast.error(
          'There was an error submitting your feedback. Please try again.',
        );
        setBtnStatus(false);
      });
  };

  const resetValue = () => {
    setRatings(Array(questions.length).fill(0));
    setDescriptions(Array(questions.length).fill(''));
    setShowAlternateQuestions(Array(questions.length).fill(false));
    setAlternateAnswers(Array(questions.length).fill(''));
    setSelectedOption(null);
  };

  const handleClose = () => {
    resetValue();
    onClose();
  };

  const starStyle = {
    cursor: 'pointer',
    fontSize: '24px',
  };

  const selectedStarStyle = {
    ...starStyle,
    color: '#F8B84E',
  };

  const unselectedStarStyle = {
    ...starStyle,
    color: 'lightgray',
  };

  const handleChange = option => {
    setSelectedOption(option);
  };

  return (
    <SwOffCanvas
      show={show}
      onClose={handleClose}
      title={surveyProps[0]?.header}
      placement="end"
      size="md"
      className="SurveyModal"
      footer={
        <div className="d-flex justify-content-end gap-2">
          <SwButton
            variant="dark-outline"
            type="button"
            onClick={resetValue}
          >
            Reset
            
          </SwButton>
          <SwButton
            variant="primary"
           
            onClick={handleSubmitFeedback}
            loading={btnStatus}
          >
            Submit
          </SwButton>
        </div>
      }
    >
      <form>
        <div className="d-flex align-items-center mb-3">
          <div className="d-flex align-items-center flex-grow-1">
            <img
              src="img/location-icon.svg"
              alt=""
              className="me-2"
            />
            <div style={{width:"200px"}}>
              <SwSelect
                value={selectedOption}
                onChange={handleChange}
                options={locationOptions}
                placeholder="Select a Location"
                // className="SurveyListSelect"
                isSearchable={false}
                isClearable={true}
              />
            </div>
            <span className='SwTextDanger ms-2'>*</span>
          </div>
        </div>

        {subheader && (
          <div className="subheader_Content1 mb-3">
            <h5>{subheader}</h5>
            <p dangerouslySetInnerHTML={{ __html: subheader1 }} />
          </div>
        )}
        <div className="row">
          {questions.map((q, qIndex) => (
            <div className="col-md-12 mt-3" key={qIndex}>
              <div className="formAddmemGrid">
                <label>
                  {q.question} <span style={{ color: 'red' }}>*</span>
                </label>

                {/* Star rating questions */}
                {q.answerType === 1 || q.answerType === 5 ? (
                  <div className="FeedBackstars">
                    {[...Array(q.answerType === 5 ? 10 : 5)].map(
                      (_, index) => (
                        <span
                          key={index}
                          style={
                            index < ratings[qIndex]
                              ? selectedStarStyle
                              : unselectedStarStyle
                          }
                          onClick={() =>
                            handleRating(qIndex, index + 1)
                          }
                        >
                          &#9733;
                        </span>
                      ),
                    )}
                  </div>
                ) : q.answerType === 3 ? (
                  /* Single choice (radio) questions */
                  <div>
                    {q.multipleChoice.map((option, optIndex) => (
                      <SwRadio
                        key={optIndex}
                        id={`survey-radio-${qIndex}-${optIndex}`}
                        name={`survey-question-${qIndex}`}
                        label={option}
                        value={optIndex + 1}
                        checked={ratings[qIndex] === optIndex + 1}
                        onChange={() =>
                          handleRating(qIndex, optIndex + 1)
                        }
                      />
                    ))}
                    {q.textOption &&
                      ratings[qIndex] === q.multipleChoice.length && (
                        <SwInput
                          value={descriptions[qIndex]}
                          onChange={event =>
                            handleDescriptionChange(qIndex, event)
                          }
                          className="mt-2"
                          placeholder="Please specify"
                        />
                      )}
                  </div>
                ) : q.answerType === 4 ? (
                  /* Multi-select (checkbox) questions */
                  <div>
                    {q.multipleChoice.map((option, optIndex) => (
                      <SwCheckbox
                        key={optIndex}
                        id={`survey-checkbox-${qIndex}-${optIndex}`}
                        label={option}
                        checked={multipleChoiceLow[
                          qIndex
                        ]?.includes(option)}
                        onChange={() =>
                          handleCheckboxChange(
                            qIndex,
                            option,
                            'low',
                          )
                        }
                      />
                    ))}
                    {q.textOption &&
                    multipleChoiceLow[qIndex]?.includes(
                      q.multipleChoice[q.multipleChoice.length - 1],
                    ) && (
                        <SwInput
                          value={descriptions[qIndex]}
                          onChange={event =>
                            handleDescriptionChange(qIndex, event)
                          }
                          className="mt-2"
                          placeholder="Please specify"
                        />
                      )}
                  </div>
                ) : (
                  /* Text/description questions */
                  <SwTextArea
                    value={descriptions[qIndex]}
                    onChange={event =>
                      handleDescriptionChange(qIndex, event)
                    }
                    rows={4}
                  />
                )}
              </div>

              {/* Alternate Questions - Low */}
              {showAlternateQuestions[qIndex] === 'low' && (
                <div className="alternate-low mt-2">
                  <div className="formAddmemGrid">
                    <label>{q.alternateLowQuestion}</label>
                    {q.multipleChoice &&
                    q.multipleChoice.filter(opt => opt).length > 0 ? (
                      q.multipleChoice.map((option, optIndex) => (
                        <SwCheckbox
                          key={optIndex}
                          id={`survey-alt-low-${qIndex}-${optIndex}`}
                          label={option}
                          checked={multipleChoiceLow[
                            qIndex
                          ]?.includes(option)}
                          onChange={() =>
                            handleCheckboxChange(
                              qIndex,
                              option,
                              'low',
                            )
                          }
                          className="mb-2"
                        />
                      ))
                    ) : (
                      <SwTextArea
                        value={alternateAnswers[qIndex]}
                        onChange={event =>
                          handleAlternateAnswerChange(qIndex, event)
                        }
                        rows={4}
                      />
                    )}
                  </div>
                </div>
              )}

              {/* Alternate Questions - High */}
              {showAlternateQuestions[qIndex] === 'high' && (
                <div className="alternate-high mt-2">
                  <div className="formAddmemGrid">
                    <label>{q.alternateHighQuestion}</label>
                    {q.multipleChoice &&
                    q.multipleChoice.filter(opt => opt).length > 0 ? (
                      q.multipleChoice.map((option, optIndex) => (
                        <SwCheckbox
                          key={optIndex}
                          id={`survey-alt-high-${qIndex}-${optIndex}`}
                          label={option}
                          checked={multipleChoiceHigh[
                            qIndex
                          ]?.includes(option)}
                          onChange={() =>
                            handleCheckboxChange(
                              qIndex,
                              option,
                              'high',
                            )
                          }
                          className="mb-2"
                        />
                      ))
                    ) : (
                      <SwTextArea
                        value={alternateAnswers[qIndex]}
                        onChange={event =>
                          handleAlternateAnswerChange(qIndex, event)
                        }
                        rows={4}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {footerScale && (
          <div
            className="survey-footer mt-2"
            style={{ fontWeight: '600', fontSize: '12px' }}
          >
            <p>{footerScale}</p>
            <p>{footerDetail}</p>
          </div>
        )}
      </form>
    </SwOffCanvas>
  );
};

export default FeedbackRating;
